import type { ReactNode } from 'react';
import { Provider } from 'react-redux';
import type { IStoresData, IStoresRenderer } from '../interface';

function renderer(store: IStoresData): IStoresRenderer {
    const StoreRender = (props: { children?: ReactNode }): JSX.Element => (
        <Provider store={store.store}>{props.children}</Provider>
    );

    const storeRender: IStoresRenderer = {
        render: StoreRender,
    };

    return storeRender;
}

export default renderer;
